<template>
  <layout-default>
    <template v-slot:toolbar>
      <v-btn
        elevation="0"
        class="ml-auto"
        color="accent"
        small
        rounded
        @click="incrementHourTemplateMessages"
        >Add 1 hour to all messages</v-btn
      >
      <v-btn
        class="ml-2 mr-auto"
        elevation="0"
        color="accent"
        small
        rounded
        @click="decrementHourTemplateMessages"
        >Subtract 1 hour from all messages</v-btn
      >
    </template>
    <div id="template" class="v-inner--wrap">
      <preview-zoom-dialog
        :dialogType="dialogType"
        :imageSrc="imageSrc"
        :dialogFile="dialogFile"
        :dialogFileMlUrl="dialogFileMlUrl"
        :name="imageName"
        @close-dialog="closeMediaDialog"
        @reload-resource="reloadImageResource"
      />
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <inner-drawer>
        <template v-slot:header>
          <template-card
            :user="template"
            @delete="prepareDeleteTemplate"
            @duplicate="prepareDuplicateTemplate"
            @input-update="prepareEditTemplate"
            @practices-update="prepareTemplatePractices"
          />
        </template>
      </inner-drawer>
      <template-messages-container
        :days="newTemplateData.days"
        :forceRedraw="messagesContainerRedraw"
        :isProcedureDateRelated="template.isProcedureDateRelated"
        @new-message="prepareNewMessage"
        @edit-message="prepareEditMessage"
        @delete-message="openConfirmDeleteDialog"
        @copy-message="copyTemplateMessage"
        @update-messages="prepareEditMessages"
      />
      <template-message-dialog
        ref="templateMessageDialog"
        :show-dialog="showNewMessageDialog"
        :key="newMessageDialogKey"
        @close-message-dialog="closeNewMessageDialog"
        @on-submit="addTemplateMessage"
        @on-edit="editTemplateMessage"
        @reload-resource="reloadMessageResource"
        @clear-resource="clearMessageResource"
        @show-bigger-image="showBiggerImage"
        :day="newMessageDay"
        :get-resource="getResource"
        :message-resource="messageResource ? messageResource : false"
        :resource="resource ? resource : false"
        :edited-message="messageToEdit"
      />
      <v-dialog
        v-model="showConfirmDeleteDialog"
        persistent
        max-width="500"
        @click:outside="onClickOutside"
        @keydown="onKeydown"
      >
        <v-card>
          <v-card-title class="headline"
            >Are you sure you want to delete this item? 🥵</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="rounded-pill" text @click="closeConfirmDeleteDialog"
              >No</v-btn
            >
            <v-btn
              class="rounded-pill elevation-0"
              color="accent"
              @click="prepareDeleteMessage"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deleteMessagePopup"
        persistent
        max-width="450"
        @click:outside="onClickOutside"
        @keydown="onKeydown"
      >
        <v-card>
          <v-card-title class="headline"
            >Are you really sure you want to delete this for
            EVERYONE?</v-card-title
          >
          <v-card-text>
            This action is irreversible.
          </v-card-text>
          <v-card-actions class="v-card__actions--flexcenter">
            <v-btn class="rounded-pill" text @click="closeDeleteMessagePopup"
              >Cancel</v-btn
            >
            <v-btn
              class="rounded-pill elevation-0"
              color="accent"
              @click="deleteTemplateMessage"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import InnerDrawer from '@/components/InnerDrawer.vue'
import InnerContent from '@/components/InnerContent.vue'
import TemplateCard from '@/components/timedRelease/TemplateCard.vue'
import TemplateMessagesContainer from '@/components/timedRelease/TemplateMessagesContainer.vue'
import TemplateMessageDialog from '@/components/dialogs/TemplateMessageDialog.vue'
import LayoutDefault from '../layouts/LayoutDefault.vue'
import PreviewZoomDialog from '@/components/dialogs/PreviewZoomDialog.vue'

export default {
  name: 'Template',
  components: {
    InnerDrawer,
    TemplateCard,
    LayoutDefault,
    TemplateMessagesContainer,
    TemplateMessageDialog,
    PreviewZoomDialog,
  },
  data() {
    return {
      showNewMessageDialog: false,
      newMessageDialogKey: 1,
      newTemplateData: {},
      newMessageDay: null,
      deleteMessagePopup: false,
      messageToDelete: null,
      messageToEdit: false,
      dialogType: 0,
      imageSrc: false,
      imageName: false,
      dialogFile: null,
      dialogFileMlUrl: null,
      messageResource: null,
      messagesContainerRedraw: 0,
      showConfirmDeleteDialog: false,
    }
  },
  mounted() {
    this.getTemplate(this.templateId).then(() => {
      this.newTemplateData = { ...this.template }
    })
  },
  computed: {
    ...mapState('templatesStates', {
      template: 'template',
      templateLoading: 'loading',
    }),
    ...mapState('resourcesStates', {
      resource: 'resource',
      resourceLoading: 'loading',
    }),
    templateId() {
      return this.$route.params.id
    },
    loading() {
      return this.templateLoading || this.resourceLoading
    },
  },
  watch: {
    template: {
      handler: function(val) {
        this.newTemplateData = { ...val }
      },
    },
  },
  methods: {
    ...mapMutations('appStates', ['setSnackbarNotification']),
    ...mapActions('templatesStates', [
      'getTemplate',
      'changeTemplate',
      'duplicateTemplate',
      'deleteTemplate',
      'sharePractices',
    ]),
    ...mapActions('libraryStates', ['uploadFile']),
    ...mapActions('resourcesStates', ['getResource', 'getResourceById']),
    ...mapMutations('resourcesStates', ['setResource']),
    prepareDeleteTemplate(id) {
      this.deleteTemplate(id).then(() => {
        setTimeout(() => {
          this.$router.push({
            name: 'Timed release templates',
            path: '/sprints/',
          })
        }, 2000)
      })
    },
    prepareDuplicateTemplate(id) {
      this.duplicateTemplate(id).then(() => {
        setTimeout(() => {
          this.$router.push({
            name: 'Timed release templates',
            path: '/sprints/',
          })
        }, 2000)
      })
    },
    prepareEditTemplate(input, val) {
      this.newTemplateData[input] = val
      this.saveTemplateChanges()
    },
    prepareTemplatePractices(practices) {
      this.sharePractices({ id: this.newTemplateData.id, practices: practices })
    },
    reloadResource(id) {
      this.getResource({ id: id })
    },
    clearResource() {
      this.setResource(null)
    },
    clearMessageResource() {
      this.messageResource = null
    },
    prepareNewMessage(day) {
      this.newMessageDay = day
      this.openNewMessageDialog()
    },
    openNewMessageDialog() {
      this.showNewMessageDialog = true
    },
    closeNewMessageDialog() {
      this.newMessageDialogKey += 10
      this.clearResource()
      this.messageResource = null
      this.showNewMessageDialog = false
      this.messageToEdit = false
    },
    closeDeleteMessagePopup() {
      this.deleteMessagePopup = false
      this.messageToDelete = null
    },
    closeConfirmDeleteDialog() {
      this.showConfirmDeleteDialog = false
    },
    onClickOutside() {
      this.closeDeleteMessagePopup()
      this.closeConfirmDeleteDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) {
        this.closeDeleteMessagePopup()
        this.closeConfirmDeleteDialog()
      }
    },
    async addTemplateMessage(data) {
      let staticMediaId
      let resourceId
      let storageFileId
      if (!data.thumbnailValue) {
        resourceId = data?.resourceId
        staticMediaId = data?.staticMediaId
      } else if (data.thumbnailValue?.remove) {
        resourceId = null
        staticMediaId = null
        // resource remove
      } else if (data.thumbnailValue?.mlSourceResourceId) {
        // resource = ml id
        resourceId = data.thumbnailValue?.mlSourceResourceId
        staticMediaId = null
      } else if (data.thumbnailValue?.staticMediaId) {
        // resource = mobile static media id
        staticMediaId = data.thumbnailValue?.staticMediaId
        resourceId = null
      } else if (data.thumbnailValue?.file) {
        try {
          const fileResponse = await this.uploadFile({
            file: data.thumbnailValue.file,
          })
          storageFileId = fileResponse.data.id
          resourceId = undefined
          staticMediaId = undefined
        } catch (error) {
          // clear resource id
          resourceId = data?.resourceId || null
          staticMediaId = data?.staticMediaId || null
          if (this.$refs?.['templateMessageDialog']) {
            this.$refs?.['templateMessageDialog'].setLoadingModal(false)
          }
          return
        }
      }

      if (storageFileId) {
        data.storageFileId = storageFileId
      }

      if (resourceId === undefined) {
        delete data.resourceId
      } else {
        data.resourceId = resourceId
      }

      if (staticMediaId === undefined) {
        delete data.staticMediaId
      } else {
        data.staticMediaId = staticMediaId
      }

      const day = data.day
      delete data.day

      delete data.thumbnailValue

      let ind = this.newTemplateData.days.find(item => item.index == day)
      if (ind) ind.messages.push(data)
      else {
        let messages = []
        messages.push(data)
        this.newTemplateData.days.push({ index: day, messages: messages })
      }
      setTimeout(() => {
        this.saveTemplateChanges()
      }, 1000)
    },
    async editTemplateMessage(data) {
      // const data = { ...newData }
      const messageToEdit = this.messageToEdit
      let staticMediaId
      let resourceId
      let storageFileId
      if (!data.thumbnailValue) {
        resourceId = data?.resourceId
        staticMediaId = data?.staticMediaId
      } else if (data.thumbnailValue?.remove) {
        resourceId = null
        staticMediaId = null
        // resource remove
      } else if (data.thumbnailValue?.mlSourceResourceId) {
        // resource = ml id
        resourceId = data.thumbnailValue?.mlSourceResourceId
        staticMediaId = null
      } else if (data.thumbnailValue?.staticMediaId) {
        // resource = mobile static media id
        resourceId = null
        staticMediaId = data.thumbnailValue?.staticMediaId
      } else if (data.thumbnailValue?.file) {
        try {
          const fileResponse = await this.uploadFile({
            file: data.thumbnailValue.file,
          })
          storageFileId = fileResponse.data.id
          resourceId = undefined
          staticMediaId = undefined
        } catch (error) {
          // clear resource id
          resourceId = data?.resourceId || null
          staticMediaId = data?.staticMediaId || null
          if (this.$refs?.['templateMessageDialog']) {
            this.$refs?.['templateMessageDialog'].setLoadingModal(false)
          }
          return
        }
      }

      if (storageFileId) {
        data.storageFileId = storageFileId
      }

      if (resourceId === undefined) {
        delete data.resourceId
      } else {
        data.resourceId = resourceId
      }

      if (staticMediaId === undefined) {
        delete data.staticMediaId
      } else {
        data.staticMediaId = staticMediaId
      }

      const day = data.day
      delete data.day
      delete data.thumbnailValue

      let ind = this.newTemplateData.days.find(item => item.index == day)
      let pos = false
      if (ind)
        pos = [...(ind?.messages || [])].findIndex(
          item => item.message == messageToEdit.message,
        )
      if (pos >= 0) {
        ind.messages[pos] = data
        this.saveTemplateChanges()
      }
    },
    saveTemplateChanges() {
      this.changeTemplate({
        id: this.newTemplateData.id,
        data: this.newTemplateData,
      })
        .then(() => {
          this.messagesContainerRedraw++
        })
        .finally(() => {
          if (this.$refs?.['templateMessageDialog']) {
            this.$refs['templateMessageDialog'].closeDialog()
          }
        })
    },
    incrementHourTemplateMessages() {
      let tmpDay = false
      let daysToAdd = []
      let daysToFill = []
      this.newTemplateData.days.forEach((day, index, object) => {
        let tmpMessages = []
        day.messages.forEach((message, index2) => {
          let hour = this.$moment(message.time, 'HH:mm:ss').format('HH')
          if (hour < 23) {
            message.time = this.$moment(message.time, 'HH:mm:ss')
              .add(1, 'hours')
              .format('HH:mm:ss')
          } else {
            let messageNew = { ...message }
            messageNew.time = this.$moment(message.time, 'HH:mm:ss')
              .add(1, 'hours')
              .format('HH:mm:ss')
            tmpMessages.push({ ...messageNew })
            object[index].messages.splice(index2, 1)
          }
        })

        // if next index exists mark to add messages, if not, create new day
        if (tmpMessages.length > 0) {
          if (day.index == 89) {
            tmpMessages.forEach(tmpMsg => {
              object[index].messages.push(tmpMsg)
            })
          } else {
            let ind = this.newTemplateData.days.findIndex(
              nextDay => nextDay.index == parseInt(day.index) + 1,
            )
            if (ind > -1) {
              daysToFill.push({
                index: day.index < 89 ? parseInt(day.index) + 1 : day.index,
                messages: [...tmpMessages],
              })
            } else {
              daysToAdd.push({
                index: day.index < 89 ? parseInt(day.index) + 1 : day.index,
                messages: [...tmpMessages],
              })
            }
          }
        }

        // add waiting messages from previous day
        if (tmpDay && tmpDay.index == day.index) {
          day.messages = day.messages.concat(tmpDay.messages)
        }
      })

      // if there are any new days created, add them
      if (daysToAdd.length > 0) {
        this.newTemplateData.days = this.newTemplateData.days.concat(daysToAdd)
      }
      // if there are any days that need to have messages added, do it here outside the loop
      if (daysToFill.length > 0) {
        daysToFill.forEach(day => {
          let ind = this.newTemplateData.days.findIndex(
            d => d.index == day.index,
          )
          if (ind > -1) {
            this.newTemplateData.days[ind].messages = this.newTemplateData.days[
              ind
            ].messages.concat(day.messages)
            this.messagesContainerRedraw++
          }
        })
      }
      // clean up empty days so that a days container notices change (day removed)
      this.newTemplateData.days.forEach((day, index, object) => {
        if (day.messages.length == 0) object.splice(index, 1)
      })
      this.saveTemplateChanges()
    },
    decrementHourTemplateMessages() {
      let tmpDay = false
      let daysToAdd = []
      let daysToFill = []
      this.newTemplateData.days.forEach((day, index, object) => {
        let tmpMessages = []
        day.messages.forEach((message, index2) => {
          let hour = this.$moment(message.time, 'HH:mm:ss').format('HH')
          if (hour >= 1) {
            message.time = this.$moment(message.time, 'HH:mm:ss')
              .subtract(1, 'hours')
              .format('HH:mm:ss')
          } else {
            let messageNew = { ...message }
            messageNew.time = this.$moment(message.time, 'HH:mm:ss')
              .subtract(1, 'hours')
              .format('HH:mm:ss')
            tmpMessages.push({ ...messageNew })
            object[index].messages.splice(index2, 1)
          }
        })

        // if prev index exists flag to add messages, if not, create new day
        if (tmpMessages.length > 0) {
          if (day.index == 0) {
            tmpMessages.forEach(tmpMsg => {
              object[index].messages.push(tmpMsg)
            })
          } else {
            let ind = this.newTemplateData.days.findIndex(
              prevDay => prevDay.index == parseInt(day.index) - 1,
            )
            if (ind > -1) {
              daysToFill.push({
                index: day.index > 0 ? parseInt(day.index) - 1 : day.index,
                messages: [...tmpMessages],
              })
            } else {
              daysToAdd.push({
                index: day.index > 0 ? parseInt(day.index) - 1 : day.index,
                messages: [...tmpMessages],
              })
            }
          }
        }

        // add waiting messages from previous day
        if (tmpDay && tmpDay.index == day.index) {
          day.messages = day.messages.concat(tmpDay.messages)
        }
      })

      // if there are any new days created, add them
      if (daysToAdd.length > 0) {
        this.newTemplateData.days = this.newTemplateData.days.concat(daysToAdd)
      }
      // if there are any days that need to have messages added, do it here outside the loop
      if (daysToFill.length > 0) {
        daysToFill.forEach(day => {
          let ind = this.newTemplateData.days.findIndex(
            d => d.index == day.index,
          )
          if (ind > -1) {
            this.newTemplateData.days[ind].messages = this.newTemplateData.days[
              ind
            ].messages.concat(day.messages)
            this.messagesContainerRedraw++
          }
        })
      }
      // clean up empty days so that a days container notices change (day removed)
      this.newTemplateData.days.forEach((day, index, object) => {
        if (day.messages.length == 0) object.splice(index, 1)
      })
      this.saveTemplateChanges()
    },
    deleteTemplateMessage() {
      let ind = this.newTemplateData.days.find(
        item => item.index == this.messageToDelete.day,
      )
      if (ind && ind.messages) {
        let pos = ind.messages.findIndex(
          item => item.message == this.messageToDelete.message,
        )
        ind.messages.splice(pos, 1)
      }
      this.saveTemplateChanges()
      this.closeDeleteMessagePopup()
    },
    copyTemplateMessage(data, day) {
      let ind = this.newTemplateData.days.find(item => item.index == day)
      if (ind && ind.messages) {
        let item = ind.messages.find(item => item.message == data.message)
        ind.messages.push(item)
      }
      this.saveTemplateChanges()
      this.closeDeleteMessagePopup()
    },
    async prepareEditMessage(data, day) {
      this.newMessageDay = day
      this.messageToEdit = data
      if (data.resourceId) await this.prepareMessageResource(data.resourceId)
      this.showNewMessageDialog = true
    },
    prepareMessageResource(id) {
      this.getResourceById({ resourceId: id })
        .then(response => {
          const { data } = response
          let type = 2
          switch (data.fileTypeId) {
            case 18:
              type = 2
              break
            case 19:
              type = 4
              break
            default:
              type = 2
              break
          }
          if (data.fileUrl) {
            this.messageResource = {
              id: id,
              previewUrl: data.previewUrl,
              thumbnailUrl: data.thumbnailUrl,
              name: data.name,
              title: data.title,
              dialogFileMlUrl: data.fileUrl,
              fileUrl: data.fileUrl,
              fileTypeId: data.fileTypeId,
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    prepareEditMessages(days) {
      this.newTemplateData.days = days
      this.saveTemplateChanges()
    },
    prepareDeleteMessage() {
      this.showConfirmDeleteDialog = false
      this.deleteMessagePopup = true
    },
    showBiggerImage({ url, file, name, mlResourceUrl = null, type = 1 }) {
      this.imageSrc = url
      this.dialogFile = file
      this.imageName = name
      this.dialogFileMlUrl = mlResourceUrl
      this.dialogType = type
    },
    async reloadImageResource(id) {
      await this.getResource({ id: id })
      this.imageSrc = this.resource.fileUrl
      this.imageName = this.resource.name
    },
    async reloadMessageResource(id) {
      this.messageResource = null
      await this.prepareMessageResource(id)
    },
    closeMediaDialog() {
      this.dialogType = 0
      this.imageName = null
      this.currentFile = null
      this.imageSrc = null
      this.dialogFileMlUrl = null
      this.dialogType = null
    },
    openConfirmDeleteDialog(data, day) {
      this.messageToDelete = data
      this.messageToDelete.day = day
      this.showConfirmDeleteDialog = true
    },
  },
}
</script>
